<template>
  <v-img
    :height="height"
    :src="image ? s3BucketURL + image : images[default_image]"
    :width="width ? width : 'auto'"
    :contain="contain ? false : true"
  >
    <slot name="overlay"></slot>
  </v-img>
</template>

<script>
import images from "@/utils/images";
export default {
  props: {
    image: { type: String, default: null },
    height: { type: Number, default: 120 },
    width: { type: String, default: null },
    default_image: { type: String, default: "default" },
    contain: { type: Boolean, default: false },
  },
  data() {
    return {
      images: images,
    };
  },
};
</script>

<style>
</style>